import { Component, OnInit } from '@angular/core';
import { PostService } from 'src/app/_services/post/post.service';
import {Contact} from '../../Model/Contact';
@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  constructor(private service : PostService) { }
  user  = new Contact
  ngOnInit(): void {}
  sendPost()
  {
   
    this.service.sendPost(this.user).subscribe(res=>
      {
        console.log(res);
        this.user.description = "";
        this.user.mail = "";
        this.user.name = "";
        this.user.phone = "";
        this.user.subject = "";
        

      })
  }

}
